/* GENERATED by scripts/gen-data.mjs — bonus stage ladder, by key (from s5.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

export interface Rung {
  nKey: string;
  fKey: string;
}

export const MAXV: number = 128;

export const LADDER: Rung[] = [
  {
    "nKey": "game:ladder.0.n",
    "fKey": "game:ladder.0.f"
  },
  {
    "nKey": "game:ladder.1.n",
    "fKey": "game:ladder.1.f"
  },
  {
    "nKey": "game:ladder.2.n",
    "fKey": "game:ladder.2.f"
  },
  {
    "nKey": "game:ladder.3.n",
    "fKey": "game:ladder.3.f"
  },
  {
    "nKey": "game:ladder.4.n",
    "fKey": "game:ladder.4.f"
  },
  {
    "nKey": "game:ladder.5.n",
    "fKey": "game:ladder.5.f"
  },
  {
    "nKey": "game:ladder.6.n",
    "fKey": "game:ladder.6.f"
  }
];

export const MERGE: Record<string, string> = {
  "2": "game:merge.2",
  "3": "game:merge.3",
  "4": "game:merge.4",
  "5": "game:merge.5",
  "6": "game:merge.6",
  "7": "game:merge.7"
};

export const GOPAL = "game:gopal";
